import MixedSchema from 'yup/lib/mixed'
import inherits from 'yup/lib/util/inherits'
import { date as locale } from 'yup/lib/locale'
import isAbsent from 'yup/lib/util/isAbsent'
import moment from 'moment'
import 'moment/locale/nl'

let invalidDateTime = ''

export default DateTimeSchema

function DateTimeSchema() {
  if (!(this instanceof DateTimeSchema)) return new DateTimeSchema()

  MixedSchema.call(this, { type: 'datetime' })

  this.withMutation(() => {
    this.transform((value) => (!value instanceof String) ? invalidDateTime : value)
  })
}

inherits(DateTimeSchema, MixedSchema, {
  _typeCheck(value) {
    return (typeof value === "string")
  },

  _formatTypeCheck(value, format) {
    return moment(value, format, true).isValid()
  },

  min(min, format, message = locale.min) {
    var limit = min

    if (!limit || !this._formatTypeCheck(limit, format))
      throw new TypeError(
        `"min" must be a "${format}" formatted string`,
      )

    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: { min, format },
      test(value) {
        var momentValue = (value) ? moment(value, format, true) : null
        return isAbsent(value) || (
          momentValue && momentValue.isValid() && momentValue.isSameOrAfter(moment(limit, format, true))
        )
      },
    })
  },

  max(max, format, message = locale.max) {
    var limit = max

    if (!this._formatTypeCheck(limit, format))
      throw new TypeError(
        `"max" must be a "${format}" formatted string`,
      )

    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: { max, format },
      test(value) {
        var momentValue = (value) ? moment(value, format, true) : null
        return isAbsent(value) || (
          momentValue && momentValue.isValid() && momentValue.isSameOrBefore(moment(limit, format, true))
        )
      },
    })
  },
})


// WEBPACK FOOTER //
// ./src/components/Form/Validation/DateTime.js